import React, { useEffect, useState } from "react";
//import { useHistory } from "react-router";
import { useLocation, useHistory } from "react-router-dom";

//ACCORDION
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

//ICONS
import HomeIcon from "@material-ui/icons/Home";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import TableChartIcon from "@material-ui/icons/TableChart";
import PersonIcon from "@material-ui/icons/Person";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

//COMPONENTS
import AllPost from "./../allPost/allPost";
import AddPost from "./../addPost/addPost";
import MyProfile from "./../myProfile/myProfile";
import Subscription from "./../subscription/subscription";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  root: {
    width: "100%",
    display: "block",
    padding: "10px 15px",
  },
}));

export default function AdminDashboard() {
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();

  const [loader, setLoader] = useState(false);
  const [content, setContent] = useState("");
  const [expended, setExpended] = useState(false);

  const id = localStorage.getItem("id");

  useEffect(() => {
    const isAuth = localStorage.getItem("isAuth") === "true";

    document.title = "121five.com - Dashboard";
    if (!isAuth) {
      history.push({ pathname: "/login" });
      return false;
    }
    setLoader(false);
  }, []);

  const renderContent = (props) => {
    switch (props) {
      case "Add Posts":
        return <AddPost id={id} />;
      case "Subscription":
        return <Subscription id={id} />;
      case "All Posts":
        return <AllPost id={id} />;
      case "Home":
        return <AllPost id={id} />;
      default:
        return <MyProfile id={id} />;
    }
  };

  const changeState = (e) => {
    const contentName = e.target.innerText;
    setContent(contentName);
    setExpended(false);
  };

  const menuButtonStyle = {
    cursor: "pointer",
  };

  const menuStyle = {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "10px",
    paddingBottom: "10px",
    cursor: "pointer",
  };

  const logout = () => {
    window.localStorage.clear();
    history.replace({
      ...location,
      state: undefined,
    });
    history.push({
      pathname: "/login",
    });
  };

  return (
    <div>
      <div className={classes.root}>
        <Accordion
          className="d-lg-none"
          expanded={expended}
          onChange={() => setExpended(!expended)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>Dashboard</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <nav className="">
              <ul className="nav">
                <li
                  className="nav-item"
                  style={menuStyle}
                  onClick={(e) => changeState(e)}
                >
                  <div
                    className="menu-title"
                    name="home"
                    style={menuButtonStyle}
                  >
                    Home
                  </div>
                  <span style={{ float: "right" }}>
                    <HomeIcon fontSize="small" />
                  </span>
                </li>
                <li
                  className="nav-item"
                  style={menuStyle}
                  onClick={(e) => changeState(e)}
                >
                  <div
                    className="menu-title"
                    name="addBlog"
                    style={menuButtonStyle}
                  >
                    Add Posts
                  </div>
                  <span style={{ display: "flex", justifyContent: "flex-end" }}>
                    <FormatListBulletedIcon fontSize="small" />
                  </span>
                </li>
                <li
                  className="nav-item"
                  style={menuStyle}
                  onClick={(e) => changeState(e)}
                >
                  <span className="menu-title">All Posts</span>
                  <span style={{ display: "flex", justifyContent: "flex-end" }}>
                    <TableChartIcon fontSize="small" />
                  </span>
                </li>
                <li
                  className="nav-item"
                  style={menuStyle}
                  onClick={(e) => changeState(e)}
                >
                  <span className="menu-title">My Profile</span>
                  <span style={{ display: "flex", justifyContent: "flex-end" }}>
                    <PersonIcon fontSize="small" />
                  </span>
                </li>
                <li
                  className="nav-item"
                  style={menuStyle}
                  onClick={(e) => changeState(e)}
                >
                  <span className="menu-title">Subscription</span>
                  <span style={{ display: "flex", justifyContent: "flex-end" }}>
                    <SubscriptionsIcon fontSize="small" />
                  </span>
                </li>
                <li className="nav-item" style={menuStyle} onClick={logout}>
                  <span className="menu-title">Logout</span>
                  <span style={{ display: "flex", justifyContent: "flex-end" }}>
                    <ExitToAppIcon fontSize="small" />
                  </span>
                </li>
              </ul>
            </nav>
          </AccordionDetails>
        </Accordion>
      </div>
      <div className="container-fluid page-body-wrapper">
        <nav className="sidebar sidebar-offcanvas" id="sidebar">
          <ul className="nav">
            <li
              className="nav-item"
              style={menuStyle}
              onClick={(e) => changeState(e)}
            >
              <div className="menu-title" name="home" style={menuButtonStyle}>
                Home
              </div>
              <span style={{ float: "right" }}>
                {/* <ArrowLeftIcon color="action" /> */}
                <HomeIcon fontSize="small" />
              </span>
            </li>
            <li
              className="nav-item"
              style={menuStyle}
              onClick={(e) => changeState(e)}
            >
              <div
                className="menu-title"
                name="addBlog"
                style={menuButtonStyle}
              >
                Add Posts
              </div>
              <span style={{ display: "flex", justifyContent: "flex-end" }}>
                <FormatListBulletedIcon fontSize="small" />
              </span>
            </li>
            <li
              className="nav-item"
              style={menuStyle}
              onClick={(e) => changeState(e)}
            >
              <span className="menu-title">All Posts</span>
              <span style={{ display: "flex", justifyContent: "flex-end" }}>
                <TableChartIcon fontSize="small" />
              </span>
            </li>
            <li
              className="nav-item"
              style={menuStyle}
              onClick={(e) => changeState(e)}
            >
              <span className="menu-title">My Profile</span>
              <span style={{ display: "flex", justifyContent: "flex-end" }}>
                <PersonIcon fontSize="small" />
              </span>
            </li>
            <li
              className="nav-item"
              style={menuStyle}
              onClick={(e) => changeState(e)}
            >
              <span className="menu-title">Subscription</span>
              <span style={{ display: "flex", justifyContent: "flex-end" }}>
                <SubscriptionsIcon fontSize="small" />
              </span>
            </li>
            <li className="nav-item" style={menuStyle} onClick={logout}>
              <span className="menu-title">Logout</span>
              <span style={{ display: "flex", justifyContent: "flex-end" }}>
                <ExitToAppIcon fontSize="small" />
              </span>
            </li>
          </ul>
        </nav>
        {renderContent(content)}
        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress />
        </Backdrop>
      </div>
    </div>
  );
}
